<template>
  <b-nav-item data-test-id="SettingsLinkComponent" @click="onSettingsClick">
    <span class="text-red">Settings</span>
  </b-nav-item>
</template>

<script>
export default {
  name: "SettingsLink",
  methods: {
    onSettingsClick() {
      this.$router.push({ name: "settings" });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
</style>
